import "./index.css";
import GridBackground from "./components/grid-background";
import Modal from "./components/modal/modal";
import WhoAmI from "./components/who-am-i";
import useModalStore from "./store/modal.store";
import Education from "./components/education";
import Project from "./components/project";
import Experience from "./components/experience";
import InTouch from "./components/In-Touch";
import Achievement from "./components/achievement";
export function App() {
  const { isOpen, mode } = useModalStore()
  const modalMode = [
    {
      mode: "Who is he?",
      component: <WhoAmI />
    },
    {
      mode: "Education",
      component: <Education />
    },
    {
      mode: "Projects",
      component: <Project />
    },
    {
      mode: "Experience",
      component: <Experience />
    },
    {
      mode: "In Touch",
      component: <InTouch />
    },
    {
      mode: "Achievement",
      component: <Achievement />
    }
  ]
  return (
    <GridBackground>
      {mode &&
        <Modal>
          {modalMode.find(m => m.mode === mode)?.component}
        </Modal>
      }
    </GridBackground>
  );
}

export default App;
